export default class TransmissionsReportingApi {
    constructor(base) {
        this.base = base;
        this.baseUrl = this.base.cfg.VUE_APP_TRANSACTIONS_API_BASE_ADDRESS;
        this.transmissionsUrl = this.baseUrl + '/api/reporting/transmission';
    }

    async get(params) {

        if (!this.headers) {
            let data = await this.base.get(this.transmissionsUrl + '/$meta')
            this.headers = this.base._formatHeaders(data)
            this.$headers = data.columns
        }

        if (params.success == undefined) {
            params.success = true;
        }
        let data = await this.base.get(this.transmissionsUrl, params);
        
        if(!data || data.status === "error")
            return null;

        let dictionaries = await this.base.dictionaries.$getTransactionDictionaries();
        
        data.data = data.data.map(d => this.base.format(d, this.$headers, dictionaries))

        data.headers = this.headers;

        return data;
    }

    async getExcel(params) {
        let data = await this.base.get(this.transmissionsUrl+ '/$excel', params);        
        return data;
    }

    async getDetails(transmissionID) {
        let data = await this.base.get(this.transmissionsUrl + `/${transmissionID}`);        
        return data;
    }
}